// extracted by mini-css-extract-plugin
export default {"orderTypeContainer":"OrderType_orderTypeContainer__+1UIk","radioLabel":"OrderType_radioLabel__-7K-Y","customRadio":"OrderType_customRadio__wbncq"};